import { useLayoutEffect } from "react";
import { Cookies } from "react-cookie";
import { useTranslation } from "react-i18next";

import {
  API,
  AuthAPI
} from "#utils"

function useAxiosInterceptor() {
  const { i18n } = useTranslation();

  useLayoutEffect(() => {
    API.defaults.headers.common["Accept-Language"] = i18n.language;
  }, [i18n.language]);

  useLayoutEffect(
    () => {
      API.interceptors.request.use(
        (config) => {
          const cookies = new Cookies();
          const csrfToken = cookies.get(import.meta.env.APP_CSRF_TOKEN);
          // TODO: only send csrf tokens for post, put, patch, delete
          if (csrfToken) {
            if (!config.headers) {
              // eslint-disable-next-line no-param-reassign
              config.headers = {};
            }
            // eslint-disable-next-line no-param-reassign
            config.headers['X-CSRFToken'] = csrfToken;
            // eslint-disable-next-line no-param-reassign
            config.headers.XCSRFToken = csrfToken;
          }
          return config;
        },
        (error) => Promise.reject(error),
      );
    },
    [],
  );

  useLayoutEffect(
    () => {
      AuthAPI.interceptors.request.use(
        (config) => {
          const cookies = new Cookies();
          const csrfToken = cookies.get(import.meta.env.APP_CSRF_TOKEN);
          // TODO: only send csrf tokens for post, put, patch, delete
          if (csrfToken) {
            if (!config.headers) {
              // eslint-disable-next-line no-param-reassign
              config.headers = {};
            }
            // eslint-disable-next-line no-param-reassign
            config.headers['X-CSRFToken'] = csrfToken;
            // eslint-disable-next-line no-param-reassign
            config.headers.XCSRFToken = csrfToken;
          }
          return config;
        },
        (error) => Promise.reject(error),
      );
    },
    [],
  );
}

export default useAxiosInterceptor
